<template>
  <div class="page preview js_show" v-if="this.search.chainPersonPhone!=''&&this.search.chainPersonPhone!=null">
    <div class="page__hd" style="text-align: center">
      <h1 class="page__title">{{search.chainPersonName}},所有的</h1>
      <p class="page__desc">门店列表信息</p>
    </div>
    <div class="page__bd">
      <div class="weui-form-preview" v-for="(item,i) in shopInfoList">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label colo" v-if="item.workFlag == '3' &&  item.buildStep == 5 ">
              <i class="weui-icon-success weui-icon_msg1 "></i>已完成
            </label>
            <label class="weui-form-preview__label colo" v-if="item.workFlag== '1' ">
              <i class="weui-icon-waiting weui-icon_msg1 "></i>待审核
            </label>
            <label class="weui-form-preview__label colo" v-if="item.workFlag == '4' ">
              <i class="weui-icon-warn weui-icon_msg1 "></i>审核不通过
            </label>
            <label class="weui-form-preview__label colo" v-if="item.buildStep == '3' &&  item.buildStep != 5  ">
              <i class="weui-icon-success weui-icon_msg1 "></i>已过审
            </label>
            <em class="weui-form-preview__value">{{item.shopName}}</em>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">法人名称</label>
            <span class="weui-form-preview__value">{{item.shopExecutor}}</span>
          </div>
          <!--<div class="weui-form-preview__item">
            <label class="weui-form-preview__label">联系电话</label>
            <span class="weui-form-preview__value">{{item.shopPhone}}</span>
          </div>-->
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">营执地址</label>
            <span class="weui-form-preview__value">{{item.shopAddress}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">创建时间</label>
            <span class="weui-form-preview__value"> {{$moment(item.gmtCreate).format('YYYY-MM-DD HH:mm:ss')}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.wcheckResult!=null">
            <label class="weui-form-preview__label">审核结果</label>
            <span class="weui-form-preview__value">{{item.wcheckResult.remark}}</span>
          </div>
        </div>
        <div class="weui-form-preview__ft">
          <a class="weui-form-preview__btn weui-form-preview__btn_primary" href="javascript:" @click="shopDetail(item.id)" >详情</a>
        </div>
      </div>
      <div v-if="shopInfoList.length==0" class="weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <em class="weui-form-preview__value" style="text-align: center;color: #8c939d">无数据,等待注册提交中...</em>
          </div>
        </div>
      </div>
    </div>
    <!--<div class="page__ft" style="margin-top: 10px;margin-bottom: 10px">
      <a class="weui-btn weui-btn_primary" href="javascript:" v-if="shopInfoList.length>0" id="showTooltips" @click="handleCreate">我要加营业员</a>
    </div>-->

    <div class="page__ft" style="margin-top: 10px;margin-bottom: 10px">
      <a class="weui-btn weui-btn_primary" href="javascript:"  @click="handleCreate">我要建新</a>
    </div>

  </div>

  <div class="page preview js_show" v-else-if="this.search.chainPersonPhone==''||this.search.chainPersonPhone==null">
    <div class="page__hd" style="text-align: center">
      <h1 class="page__title">您还没注册</h1>
      <p class="page__desc" style="margin-left: 20px;margin-right: 20px">完成注册后,您才可以建设您的连锁门店数据</p>
    </div><br>
    <div class="page__ft" style="margin-top: 10px;margin-bottom: 10px">
      <a class="weui-btn weui-btn_primary" href="javascript:" id="showTooltips1" @click="registerChain">登录注册连锁总店</a>
    </div>
  </div>

</template>

<script>
export default {
  /*eslint-disable*/
  data () {
    return {
      search: {
        deptList: '',
        bossPhone: '',
        chainPersonName: '',
        chainPersonPhone: ''
      },
      shopInfoList: []

    }
  },
  methods: {
    handleSearch () {
      console.log('hi')
    },
    handleCreate(){
      //this.$router.push({path: 'workerRegister'})
      this.$router.push({path: 'jdcenter/0'})
    },
    initShopInfoList () {
      this.$axios({
        method: 'get',
        url: 'v1/wShopRegister/getShopInfoList?chainId='+this.search.chainId
      }).then((response) => {
        console.log(response)
        this.shopInfoList = response.data.data
        console.log(this.shopInfoList)
      })
    },
    shopDetail (id) {
      this.$router.push({path: 'jdcenter/'+id})
    },
  registerChain(){
    this.$router.push({path: 'jdchainRegister'})
  }
  },
  mounted(){
    let user = this.$storage.fetchStorage("user")
    if (user!=null){
      this.search.chainPersonPhone = user.userPhone
      this.search.chainPersonName = user.username
      this.search.chainId = user.id
      this.initShopInfoList()
    }
  },
  components: {

  }
}
</script>

<style>
  #app{
    width: 100%;
  }
  .btnNew{
    float: right;
    width: 26%;
    margin-top: 12px;
    margin-right: 3px;
  }
  .btnSearch{
      margin-top: 30px;
      width: 20%;
      size: medium;
  }
</style>



// WEBPACK FOOTER //
// src/views/jdDeptManage/jdchainShops.vue